module.exports = __webpack_public_path__ + "img/service-ad-2.d76bca36.png";